import { unitMapping } from '@sorare/core/src/lib/style';

import rotowireLogo from './assets/rotowireLogo.jpg';

export const RotowireSmallLogo = ({
  size = 2,
}: {
  size: keyof typeof unitMapping;
}) => <img style={{ width: unitMapping[size] }} src={rotowireLogo} alt="" />;
